"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getClassNameFactory = exports.getClassName = void 0;

var _utility = require("react-suitcssify/dist/lib/utility");

var _index = require("../index");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getClassName = function getClassName(args) {
  return (0, _utility.getClassName)(_objectSpread({
    namespace: _index.configuration.current.styles.namespace
  }, args));
};

exports.getClassName = getClassName;

var getClassNameFactory = function getClassNameFactory(componentName) {
  return function (args) {
    return getClassName(_objectSpread({
      componentName: componentName
    }, args));
  };
};

exports.getClassNameFactory = getClassNameFactory;
var _default = getClassNameFactory;
exports["default"] = _default;